import React, { FC } from 'react';

export type Props = {
  title: string;
  isActive: boolean;
  onSelected: () => void;
};

export const Tab: FC<Props> = ({ title, onSelected, isActive }) => {
  return (
    <li className={isActive ? 'selected' : ''}>
      <a className={isActive ? 'selected' : ''} onClick={onSelected}>
        {title}
      </a>
    </li>
  );
};
